module.exports = __webpack_public_path__ + "static/media/exact.183649f4.png";